export const allMediums = [
  { value: 'membership', label: 'Articles' },
  { value: 'video', label: 'Videos' },
  { value: 'magazine', label: 'Magazines' },
  { value: 'presentation', label: 'Presentations' },
]

export const NON_PUBLISHED_POST_STATES = ['DRAFT', 'FUTURE']
export const PUBLISHED_POST_STATES = ['PUBLISH']

export const CHART_ARTICLE_TAG = 'data-visualisation'
export const BENCHMARK_PRESENTATION_CATEGORY = 'benchmark-mineral-intelligence'

export const POST_TYPES = ['membership', 'magazine', 'video', 'presentation']

export const NEWSLETTERS = [
  {
    title: 'Benchmark Newsletter',
    subTitle: 'Mine to Grid Monthly',
    description:
      '360° coverage of the entire depth and breadth of energy transition supply chains. Your trusted monthly update on raw material markets, pricing trends, policy shifts, and key developments across downstream sectors',
    img: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto:best,w_700/v1747758241/assets/newsletter/Graph_BG_Overlay_uojjm2.png',
    alt: 'Benchmark Newsletter',
  },
  {
    title: 'Price Spotlight',
    description:
      'Stay up to date with EV battery supply chain price indexes, derived from Benchmark’s world-leading Price Assessments, direct to your inbox every week.',
    img: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto:best,w_700/v1747758237/assets/newsletter/Graph_BG_Overlay_1_taqohm.png',
    alt: 'Price Spotlight Newsletter',
  },
  {
    title: 'Copper Newsletter',
    description:
      'Keep ahead of the curve with weekly updates on the evolving role copper plays in the energy transition, copper prices, market dynamics and firsthand insights from Benchmark’s Beijing-based analyst on the Chinese market.',
    img: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto:best,w_700/v1747758202/assets/newsletter/copper-newsletter_xrfrbv.png',
    alt: 'Copper Weekly Newsletter',
  },
]
